import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enProducts from './locales/en/products.json';
import enUsers from './locales/en/users.json';
import enOrders from './locales/en/orders.json';
import enNavigation from './locales/en/navigation.json';
import enRates from './locales/en/rates.json';
import enCampaigns from './locales/en/campaigns.json';
import enContracts from './locales/en/contracts.json';
import enCustomers from './locales/en/customers.json';
import enLimits from './locales/en/limits.json';
import enLimitPolicies from './locales/en/limit-policies.json';
import enPricingPolicies from './locales/en/pricing-policies.json';
import enScenarios from './locales/en/scenarios.json';
import enVehicles from './locales/en/vehicles.json';
import enVouchers from './locales/en/vouchers.json';
import enParkingSessions from './locales/en/parking-sessions.json';
import enGateMonitor from './locales/en/gate-monitor.json';
import enGates from './locales/en/gates.json';
import enAlerts from './locales/en/alerts.json';
import enTariffs from './locales/en/tariffs.json';
import enSettings from './locales/en/settings.json';
import enReports from './locales/en/reports.json';

import elCommon from './locales/el/common.json';
import elDashboard from './locales/el/dashboard.json';
import elProducts from './locales/el/products.json';
import elUsers from './locales/el/users.json';
import elOrders from './locales/el/orders.json';
import elNavigation from './locales/el/navigation.json';
import elRates from './locales/el/rates.json';
import elCampaigns from './locales/el/campaigns.json';
import elContracts from './locales/el/contracts.json';
import elCustomers from './locales/el/customers.json';
import elLimits from './locales/el/limits.json';
import elLimitPolicies from './locales/el/limit-policies.json';
import elPricingPolicies from './locales/el/pricing-policies.json';
import elScenarios from './locales/el/scenarios.json';
import elVehicles from './locales/el/vehicles.json';
import elVouchers from './locales/el/vouchers.json';
import elParkingSessions from './locales/el/parking-sessions.json';
import elGateMonitor from './locales/el/gate-monitor.json';
import elAlerts from './locales/el/alerts.json';
import elTariffs from './locales/el/tariffs.json';
import elSettings from './locales/el/settings.json';
import elReports from './locales/el/reports.json';

const resources = {
	en: {
		common: enCommon,
		dashboard: enDashboard,
		products: enProducts,
		users: enUsers,
		orders: enOrders,
		navigation: enNavigation,
		rates: enRates,
		campaigns: enCampaigns,
		contracts: enContracts,
		customers: enCustomers,
		limits: enLimits,
		limitPolicies: enLimitPolicies,
		pricingPolicies: enPricingPolicies,
		scenarios: enScenarios,
		vehicles: enVehicles,
		vouchers: enVouchers,
		parkingSessions: enParkingSessions,
		gateMonitor: enGateMonitor,
		gates: enGates,
		alerts: enAlerts,
		tariffs: enTariffs,
		settings: enSettings,
		reports: enReports
	},
	el: {
		common: elCommon,
		dashboard: elDashboard,
		products: elProducts,
		users: elUsers,
		orders: elOrders,
		navigation: elNavigation,
		rates: elRates,
		campaigns: elCampaigns,
		contracts: elContracts,
		customers: elCustomers,
		limits: elLimits,
		limitPolicies: elLimitPolicies,
		pricingPolicies: elPricingPolicies,
		scenarios: elScenarios,
		vehicles: elVehicles,
		vouchers: elVouchers,
		parkingSessions: elParkingSessions,
		gateMonitor: elGateMonitor,
		gates: enGates,
		alerts: elAlerts,
		tariffs: elTariffs,
		settings: elSettings,
		reports: elReports
	}
};

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'en',
		debug: false, // Set to true for debugging

		// Language detection options
		detection: {
			order: ['localStorage', 'navigator', 'htmlTag'],
			caches: ['localStorage']
		},

		interpolation: {
			escapeValue: false // React already escapes by default
		},

		// Namespace configuration
		defaultNS: 'common',
		ns: [
			'common',
			'dashboard',
			'products',
			'users',
			'orders',
			'navigation',
			'rates',
			'campaigns',
			'contracts',
			'customers',
			'limits',
			'limitPolicies',
			'pricingPolicies',
			'scenarios',
			'vehicles',
			'vouchers',
			'parkingSessions',
			'gateMonitor',
			'gates',
			'alerts',
			'tariffs',
			'settings',
			'reports'
		]
	});

export default i18n;
